import React, { useState, useEffect, useContext } from "react";
import "./appHome.css";
import Image from "../../Assets/HomeImage.png";
import HeaderImage from "../../Assets/Header_Image.png";
import Select from "react-select";
import HeaderService from "../../Assets/Header_Service_Image.png";
import LeftLeafImage from "../../Assets/Leaf_Image_Left.png";
import RightLeafImage from "../../Assets/Leaf_Image_Righ.png";
import HeaderMassage from "../../Assets/Header_Massage.png";
import AboutGroup from "../../Assets/About_Group.png";
import { json, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import {
  getAllBranches,
  getAllCategoriesByBrancheId,
  getAllServicesByCategoryId,
  getHomeContent,
} from "../../APIs/Api";
import BranchList from "../../Components/BranchList/BranchList";
import { PopupContext } from "../../Context/PopupContext";
import BranchPopupModel from "../../Components/BranchPopupModel";
import { isNullOrEmpty } from "../../Utils/TextUtils";
import { CustomError } from "../../Components/Toast";
import { useTranslation } from "react-i18next";
import ServicesPopupModel from "../../Components/ServicesPopupModel";

const Home = () => {
  const { isBranchSelectedFromPopUp, isBranchSelectedFromNavbar } =
    useContext(PopupContext);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  //#region states/variable initialization
  // let branchData = useSelector((state) => state.BranchData);
  let branch = localStorage.getItem("branchData");
  let branchData = JSON.parse(branch);
  const navigate = useNavigate();
  let userId = localStorage.getItem("customerId");
  let [selectedService, setSelectedService] = useState("");
  let [categoriesOptions, setCategoriesOptions] = useState([]);
  let [selectedCategory, setSelectedCategory] = useState("");
  let [servicesOptions, setServicesOptions] = useState([]);
  const [branchPopupVisibility, setBranchPopupVisibilityPopup] =
    useState(false);
  const [title1, setTitle1] = useState("");
  const [title1Ar, setTitle1Ar] = useState("");
  const [description1, setDescription1] = useState("");
  const [description1Ar, setDescription1Ar] = useState("");
  const [title2, setTitle2] = useState("");
  const [title2Ar, setTitle2Ar] = useState("");
  const [description2, setDescription2] = useState("");
  const [description2Ar, setDescription2Ar] = useState("");
  const [title3, setTitle3] = useState("");
  const [title3Ar, setTitle3Ar] = useState("");
  const [description3, setDescription3] = useState("");
  const [description3Ar, setDescription3Ar] = useState("");
  //#endregion

  //#region localization code
  const { t, i18n } = useTranslation();
  let [isArabic, setIsArabic] = useState(
    i18n.resolvedLanguage == "ar" ? true : false
  );
  useEffect(() => {
    getHomeContentCall();
    if (i18n.resolvedLanguage == "en") {
      setIsArabic((isArabic = false));
    } else {
      setIsArabic((isArabic = true));
    }
  }, [i18n.resolvedLanguage]);
  //#endregion

  useEffect(() => {
    getAllBranchCategories();
  }, [isBranchSelectedFromPopUp, isArabic]);

  //TEST EFFECTS
  useEffect(() => {
    console.log("selectedService", selectedService);
  }, [selectedService]);

  //#region Api calls
  const getAllBranchCategories = () => {
    let categoriesArr = [];
    let branchId = branchData ? branchData.id : 0;
    getAllCategoriesByBrancheId(1, 1000, branchId)
      .then((res) => {
        if (res.data.data.getAllCategorys.error_code == 0) {
          for (
            let index = 0;
            index < res.data.data.getAllCategorys.result.length;
            index++
          ) {
            const element = res.data.data.getAllCategorys.result[index];

            if (isArabic) {
              let object = {
                label: element.name_ar,
                value: element.id,
              };
              categoriesArr.push(object);
            } else {
              let object = {
                label: element.name,
                value: element.id,
              };
              categoriesArr.push(object);
            }
          }
          setCategoriesOptions((categoriesOptions = categoriesArr));
          setSelectedCategory((selectedCategory = categoriesOptions[0]));
          getAllBranchServicesByCategory(categoriesOptions[0].value);
        } else if (res.data.data.getAllCategorys.error_code == 4) {
          setCategoriesOptions((categoriesOptions = []));
          setSelectedCategory((selectedCategory = ""));
          setServicesOptions((servicesOptions = []));
          setSelectedService((selectedService = ""));
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAllBranchServicesByCategory = (categoryId) => {
    let servicesArr = [];
    let branchId = branchData ? branchData.id : 0;

    getAllServicesByCategoryId(1, 1000, branchId, categoryId)
      .then((res) => {
        if (res.data.data.getAllServices.success) {
          console.log(
            "res.data.data.getAllServices.result",
            res.data.data.getAllServices.result
          );

          for (
            let index = 0;
            index < res.data.data.getAllServices.result.length;
            index++
          ) {
            const element = res.data.data.getAllServices.result[index];

            let obj = null;

            if (isArabic) {
              obj = {
                label: element.name_ar,
                value: element.id,
                description: element.description_ar,
                price: element.price,
                time: element.time,
              };
            } else {
              obj = {
                label: element.name,
                value: element.id,
                description: element.description,
                price: element.price,
                time: element.time,
              };
            }

            if (obj != null) servicesArr.push(obj);
          }

          setServicesOptions((servicesOptions = servicesArr));
          setSelectedService((selectedService = servicesOptions[0]));
        } else {
          if (res.data.data.getAllServices.message == "No Record Found.") {
            setServicesOptions((servicesOptions = []));
            setSelectedService((selectedService = ""));
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getHomeContentCall = () => {
    getHomeContent()
      .then((res) => {
        if (res.data.data.getOrganizationalSettingHomeContent.error_code == 0) {
          var data = res.data.data.getOrganizationalSettingHomeContent.result;
          setTitle1(data[0].title);
          setTitle1Ar(data[0].title_ar);
          setDescription1(data[0].description);
          setDescription1Ar(data[0].description_ar);
          setTitle2(data[1].title);
          setTitle2Ar(data[1].title_ar);
          setDescription2(data[1].description);
          setDescription2Ar(data[1].description_ar);
          setTitle3(data[2].title);
          setTitle3Ar(data[2].title_ar);
          setDescription3(data[2].description);
          setDescription3Ar(data[2].description_ar);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  //#endregion

  return (
    <div className="home_wrapper">
      {!isBranchSelectedFromPopUp && !isBranchSelectedFromNavbar ? (
        <BranchPopupModel />
      ) : null}
      {/* <ServicesPopupModel setBranchPopupVisibilityPopup={setBranchPopupVisibilityPopup} />
       {
        branchPopupVisibility &&  <BranchPopupModel />
       } */}

      <section className={"header_Booking_Section_Container"}>
        <div className={"Header_Image_Wrapper"}>
          <img src={Image} alt="header_Image" className={"ImageStyle"} />
        </div>

        <div className={"Header_Booking_Content_Wrapper"}>
          <div className={"Discover_Text_Style"}>
            {/* {t("discover_the_gorgeous_shine_within_us")} */}
            {isArabic ? title1Ar : title1}
          </div>

          <p className={"Lorem_Text_Style"}>
            {isArabic ? description1Ar : description1}
          </p>

          <button
            className={"Book_Button_Style"}
            onClick={() => {
              if (userId) navigate("/bookappointment");
              else navigate("/login");
            }}
          >
            {t("book_your_appointment")}
          </button>
        </div>
      </section>

      <section className={"Header_Service_Secttion_Container"}>
        <div className={"Servive_Range_Text_Style"}>
          {t("we_provide_a_full_range_of_services")}
        </div>

        {/* Image with Possition absolute */}
        <div className={"Header_Service_Bg_ImageStyle"}>
          <img
            src={HeaderImage}
            alt="image"
            className={"Header_Service_Image_Style"}
          />
        </div>

        {/* Image with Possition absolute */}
        <div className={"Header_Service_Content_Conatiner"}>
          <div className="Select_Main_Content_Container">
            <div className={"Select_Container"}>
              <Select
                placeholder={t("category")}
                options={categoriesOptions}
                className={"Header_Select_Option_Style"}
                classNamePrefix="Select"
                value={selectedCategory}
                onChange={(event) => {
                  setSelectedCategory((selectedCategory = event));
                  getAllBranchServicesByCategory(selectedCategory.value);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isSearchable={false}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused ? "white" : null,
                    borderRadius: "25px",
                    border: state.isFocused ? 0 : 0,
                    outline: state.isFocused ? "none" : "none",
                    boxShadow: "none",
                    cursor: "pointer",
                  }),
                }}
              />
            </div>

            <ul className="service_category_Container">
              {servicesOptions.map((item) => (
                <li
                  className={
                    selectedService.label == item.label
                      ? "service_Name_Style"
                      : "Service_Item_Style"
                  }
                  onClick={() => {
                    setSelectedService(item);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>

          <div className={"Service_Mask_Image_Content_Conatiner"}>
            <div className={"Service_Mask_Image_Conatiner"}>
              <img
                src={HeaderService}
                alt="Image_"
                className={"Service_Mask_ImageStyle"}
              />
            </div>

            <div className={"Service_Mask_Text_Container"}>
              <div className={"Service_Name_Text_Style"}>
                {selectedService.label}
              </div>

              <p className={"Service_Mask_Lorem_Text"}>
                {selectedService.time} minutes
              </p>

              <p className={"Service_Mask_Lorem_Text"}>
                {selectedService.description}
              </p>

              <button
                className={"Service_Book_Button"}
                // disabled={!userId && isNullOrEmpty(selectedService) ? true : false}
                onClick={() => {
                  if (!userId) {
                    CustomError(
                      t("in_order_to_book_your_appointment_please_login_first")
                    );
                  } else if (userId && isNullOrEmpty(selectedService)) {
                    CustomError(t("select_a_service_first"));
                  } else if (userId && !isNullOrEmpty(selectedService)) {
                    navigate("/bookappointmentdate", {
                      state: {
                        selectedService: selectedService,
                      },
                    });
                  }
                }}
              >
                {t("book_now")}
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className={"Header_About_Main_Container"}>
        <div className={"Header_About_Bg"}>
          {/* <div className={"LeftLeafImage_Container"}>
            <img
              src={LeftLeafImage}
              alt="Image"
              className={"LeftLeafImage_Style"}
            />
          </div>
          <div className={"RightLeafImage_Container"}>
            <img
              src={RightLeafImage}
              alt="Image"
              className={"RightLeafImage_Style"}
            />
          </div> */}

          <div className={"About_Content_Main_Container"}>
            <div className={"Header_About_Text_Container"}>
              <div className={"Header_About_Massage_Heading_Style"}>
                {/* {t("an_atmosphere_of_serenity_comfort")} */}
                {isArabic ? title2Ar : title2}
              </div>

              <p className={"Lorem_Massage_Text_Style"}>
                {isArabic ? description2Ar : description2}
              </p>
            </div>

            <div className={"Header_Massage_Image_Conatiner"}>
              <img
                src={HeaderMassage}
                alt="Image"
                className={"Header_Massage_Image_Style"}
              />
            </div>
          </div>
        </div>

        <div className={"About_Main_Content_Container"}>
          <div className={"About_Group_Image_Container"}>
            <img
              src={AboutGroup}
              alt="Image"
              className={"About_Group_Image_Style"}
            />
          </div>

          <div className={"About_Text_Main_Container"}>
            <div className={"About_Heading_Text_Style"}>
              {/* {t("about_saloon_services")} */}
              {isArabic ? title3Ar : title3}
            </div>

            <p className={"About_About_Lorem_Paragraph"}>
              {isArabic ? description3Ar : description3}
            </p>

            {/* <button className={"About_Learn_Button"}>{t("learn_more")}</button> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
